"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "GRAPHQL_WS", {
    enumerable: true,
    get: function() {
        return GRAPHQL_WS;
    }
});
var GRAPHQL_WS = "graphql-ws";

//# sourceMappingURL=protocol.js.map